<template>
  <div>
    <el-dialog title="登录中心"
               style="text-align: center;"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               width="400px"
               @close="close">
      <!-- <div class="login_box"></div> -->
      <!-- 		<wxlogin id="login_box" appid="wx652a62396d67968f" :scope="'snsapi_login'" :theme="'black'"
				:href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKICAJZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAuc3RhdHVzLnN0YXR1c19icm93c2VyIHsKICAJZGlzcGxheTogbm9uZTsKICAgICAgIGNvbG9yOiMwMDA7Cn0KLmltcG93ZXJCb3ggLnFyY29kZSB7CiAgCWJvcmRlcjogbm9uZTsKICAJd2lkdGg6IDI0MHB4OwogIAloZWlnaHQ6IDI0MHB4OwogICAgICAgIGNvbG9yOiMwMDA7Cn0KLmltcG93ZXJCb3ggLnN0YXR1c3sKICAJZGlzcGxheTogbm9uZTsKICAgICAgICBjb2xvcjojMDAwOwp9'"
				:redirect_uri='redirect_uri' :state="`${Math.random()}`">
			</wxlogin> -->

      <div>
        <el-tabs v-if="!RegisterFlag"
                 v-model="loginType">
          <el-tab-pane label="验证码登录"
                       name="code">
            <el-form ref="formcode"
                     :rules="rulescode"
                     :model="formcode">
              <el-form-item prop="mobile"
                            required>
                <el-input placeholder="手机号"
                          :maxlength="11"
                          clearable
                          prefix-icon="el-icon-mobile-phone"
                          v-model="formcode.mobile"></el-input>
              </el-form-item>
              <el-form-item prop="smsCode"
                            required>
                <el-input placeholder="验证码"
                          clearable
                          maxlength="6"
                          prefix-icon="el-icon-circle-check"
                          v-model="formcode.smsCode">
                  <template slot="append"><span @click="getCode(1)">{{vcodeBtnName}}</span></template>
                </el-input>
              </el-form-item>
              <!-- <el-button type="text"
                         @click="RegisterFlag = true"
                         style="margin-bottom:10px">还没有账号,去注册</el-button> -->
              <el-form-item>
                <el-button style="width:100%"
                           type="danger"
                           @click="submitForm('formcode')">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="密码登录"
                       name="pas">
            <el-form ref="formpas"
                     :rules="rulespas"
                     :model="formpas">
              <el-form-item prop="mobile"
                            required>
                <el-input placeholder="登录账号"
                          clearable
                          prefix-icon="el-icon-user"
                          v-model="formpas.mobile"></el-input>
              </el-form-item>
              <el-form-item prop="password"
                            required>
                <el-input placeholder="密码"
                          clearable
                          type="password"
                          prefix-icon="el-icon-circle-check"
                          v-model="formpas.password"></el-input>
              </el-form-item>
              <!-- <el-button type="text"
                         @click="RegisterFlag = true"
                         style="margin-bottom:10px">还没有账号,去注册</el-button> -->
              <el-form-item>
                <el-button style="width:100%"
                           type="danger"
                           @click="submitForm('formpas')">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <el-form v-else
                 ref="RegisterForm"
                 :rules="rulesRegisterForm"
                 :model="RegisterForm">
          <el-form-item prop="userName">
            <el-input placeholder="用户名"
                      clearable
                      prefix-icon="el-icon-user"
                      v-model="RegisterForm.userName"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input placeholder="密码"
                      clearable
                      type="password"
                      prefix-icon="el-icon-circle-check"
                      v-model="RegisterForm.password"></el-input>
          </el-form-item>
          <el-form-item prop="mobile"
                        required>
            <el-input placeholder="手机号"
                      :maxlength="11"
                      clearable
                      prefix-icon="el-icon-mobile-phone"
                      v-model="RegisterForm.mobile"></el-input>
          </el-form-item>
          <el-form-item prop="smsCode"
                        required>
            <el-input placeholder="验证码"
                      clearable
                      maxlength="6"
                      prefix-icon="el-icon-circle-check"
                      v-model="RegisterForm.smsCode">
              <template slot="append"><span @click="getCode(2)">{{vcodeBtnName}}</span></template>
            </el-input>
          </el-form-item>
          <el-button type="text"
                     @click="RegisterFlag = false"
                     style="margin-bottom:10px">去登录</el-button>
          <el-form-item>
            <el-button style="width:100%"
                       type="danger"
                       @click="submitForm('RegisterForm')">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- <wxlogin class="login"
               id="login_box"
               appid="wx652a62396d67968f"
               :scope="'snsapi_login'"
               :theme="'black'"
               :redirect_uri='redirect_uri'
               :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewogIHdpZHRoOiAyMjVweDsKICBoZWlnaHQ6IDIyNXB4Owp9'"
               :state="`${Math.random()}`">
      </wxlogin> -->
      <span>登录即表示同意钧策咨询 <span class="mainColor"
              style="cursor: pointer;"
              @click="getresourceList">《用户隐私条款》</span> </span>
      <!-- 《用户协议》& -->
      <!-- 协议 -->
      <el-dialog width="500px"
                 title="用户隐私条款"
                 :visible.sync="innerVisible"
                 :close-on-click-modal="false"
                 append-to-body>
        <div class="inner_box">
          <div v-html="resourceUrl"></div>
        </div>
        <div class="flexCenter"
             style="margin-top:20px">
          <el-button type="danger"
                     @click="innerVisible = false">好的</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
// 局部引入
import wxlogin from 'vue-wxlogin';
import { platformLogin, platformRegister, sendSmsCode, resourceList } from '@/api/api.js'
export default {
  components: {
    wxlogin
  },
  data () {
    const validateMobile = (rule, value, callback) => {
      let regPhone = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if (value === '') {
        callback(new Error('请填写手机号'));
      } else if (!regPhone.test(value)) {
        callback(new Error('请输入正确的手机号格式!'));
      } else {
        callback();
      }
    };
    return {
      rulespas: {
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ],
      },
      rulescode: {
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ],
      },
      rulesRegisterForm: {
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ],
      },
      formpas: { mobile: '', password: '' },
      formcode: { mobile: '', smsCode: '' },
      RegisterForm: { mobile: '', smsCode: '', userName: '', password: '' },
      loginType: 'code',
      redirect_uri: encodeURIComponent('http://www.cyxin.com.cn/#/'),
      vcodeBtnName: '获取验证码',
      countNum: 120,
      countDownTimer: null,
      RegisterFlag: false,
      innerVisible: false,
      resourceUrl: '',
      data: {
        showIndex: 26,
        pageNumber: 1,
        pageSize: 100
      },
    }
  },
  props: {
    dialogVisible: {
      type: Boolean
    }
  },
  methods: {
    async getresourceList () {  //获取首页资源
      const res = await resourceList(this.data)
      // console.log(res)
      if (res.data) {
        this.resourceUrl = res.data[0].resourceUrl
      }
      this.innerVisible = true;
      console.log(res)
    },
    close () {
      this.$emit('close', false)
    },
    async getCode (type) {
      if (this.vcodeBtnName != '获取验证码' && this.vcodeBtnName != '重新发送') {
        return false
      }
      const res = await sendSmsCode(type == 1 ? this.formcode.mobile : this.RegisterForm.mobile)
      if (res && (res.code == 200 || res.code == 0)) {
        this.$message({
          showClose: true,
          message: '短信已发送，请注意查收',
          type: 'success'
        });
        this.countNum = 60;
        this.countDownTimer = setInterval(() => {
          this.countDown();
        }, 1000);
      }

    },
    // 倒计时
    countDown () {
      if (this.countNum < 1) {
        clearInterval(this.countDownTimer);
        this.vcodeBtnName = '重新发送';
        return;
      }
      this.countNum--;
      this.vcodeBtnName = this.countNum + '秒重发';
    },
    submitForm (formName) {
      console.log(formName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getLogin(formName)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async getLogin (type) {
      var res = null
      if (type != 'RegisterForm') {
        res = await platformLogin(this[type])
      } else {
        res = await platformRegister(this[type])
      }
      if (res && res.code == 200) {
        console.log(res)
        localStorage.setItem('accessToken', res.data.accessToken)
        localStorage.setItem('info', JSON.stringify(res.data))
        this.$message({
          showClose: true,
          message: '恭喜你，登录成功!',
          type: 'success'
        });
        setTimeout(() => {
          this.close()
          window.location.reload()
          // console.log(this.$route)
          // if (this.$route.path != '/') {
          //   this.$router.push('/')
          // }
        }, 200);
      }
    }
  }
}
</script>

<style>
.el-input-group__append {
  background-color: #fff !important;
  color: blue;
  cursor: pointer;
}
.inner_box {
  max-height: 500px;
  overflow-y: auto;
  padding-right: 10px;
}
.login_box {
  margin: 20px auto;
  width: 240px;
  height: 240px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
}
#login_box {
  margin: 0 auto;
  height: 330px;
  /* width: 240px; */
  /* height: 240px; */
  /* background: #FFFFFF; */
  /* box-shadow: 0px 2px 4px 0px rgba(196, 196, 196, 0.5000); */
  /* border-radius: 8px; */
}
</style>
